import React from 'react'
import './Portfolio.css'
import CCNA1 from '../../assets/CCNA1.jpg'
import CCNA2 from '../../assets/CCNA2.jpg'
import CCNA3 from '../../assets/CCNA3.jpg'
import Raite from '../../assets/Raite.jpg'
import JS1 from '../../assets/webdesign.png'
import JS2 from '../../assets/Javascript.png'

const Portfolio = () => {
    return (
        <section id="portfolio">

            <h2><b>My Certificates</b></h2>


            <div className="container portfolio__container">

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={Raite} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>RAITE: Digital Economy and Cryptocurrency through Gamification: An Emergin Platform in the New Normal</h3>
                        <h5>September 12, 2021</h5>
                    </div>
                </article>

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={CCNA1} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>CCNA Routing and Switching: Connecting Networks</h3>
                        <h5>July 21, 2021</h5>
                    </div>
                </article>

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={CCNA3} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>CCNA Routing and Switching: Scaling Networks</h3>
                        <h5>December 20, 2020</h5>
                    </div>
                </article>

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={CCNA2} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>CCNA Routing and Switching: Introduction to Networks</h3>
                        <h5>December 15, 2019</h5>
                    </div>
                </article>

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={JS1} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>Responsive Web Design</h3>
                        <h5>September 30, 2022</h5>
                    </div>
                </article>

                <article className="portfolio__item">
                    <div className="portfolio__item-img">
                        <img src={JS2} alt="" />
                    </div>
                    <div className="portfolio__item-cta">
                        <h3>JavaScript Algorithms and Data Structures</h3>
                        <h5>October 02, 2022</h5>
                    </div>
                </article>



            </div>
        </section>
    )
}

export default Portfolio